var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-2sm text-text-muted w-12 mr-6"},[_vm._v(" "+_vm._s(_vm.$moment.unix(_vm.date).format(_vm.dateFormat))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }